<script setup lang="ts">
defineProps({
  countViews: {
    type: Number,
    default: 0,
  },
  isAtom: {
    type: Boolean,
    default: false,
  },
});
const textInfo = computed(() => {
  return 'сделали выбор';
});
</script>

<template>
  <div v-if="isAtom ? countViews > 100 : countViews" class="rating-view-wrap">
    <div class="rating-view-icon"></div>
    <div class="rating-view-title body-m-regular">
      {{ countViews ? countViews + ' ' + textInfo : '&nbsp;' }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.rating-view-wrap {
  display: flex;
  align-items: flex-start;

  .rating-view-icon {
    position: relative;

    &:before {
      position: absolute;
      top: 1px;
      content: '';
      width: 16px;
      height: 16px;
      background: url('/static/images/icon/users.svg') center / contain
        no-repeat;
      @include xl-block {
        top: 2px;
      }
    }
  }

  .rating-view-title {
    position: relative;
    white-space: nowrap;
    margin-left: 20px;
    color: $achromatic-disabled;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 179px;
    @include lg-block {
      text-overflow: initial;
      max-width: 100%;
    }
  }
}
</style>
